export { default } from './bonus-points';
